var docName = '';
var base_url = "https://obfys.docendorse.com";
var dialogBox = null;
var isRunning = false;
var refreshOnDialogClose = false;
var default_name = "unsaved_document";
var default_ext = ".docx";
var main_container = grab('.main_container');
var secondary_container = grab('.profile-card');
var loading_cover = grab('.loading_cover');
var spinner = grab('.spinner');


function installAddIn(info){

  if (info.host === Office.HostType.Word || info.host === Office.HostType.PowerPoint || info.host ===  Office.HostType.Excel ){
    secondary_container.hideItem();
    main_container.showItem();

    if( info.host === Office.HostType.PowerPoint ){
      default_ext = ".pptx";
    } else if (info.host ===  Office.HostType.Excel){
      default_ext = ".xlsx";
    }
      
    var titles = Array.from(grabAll('.document_name_or_title')),
    nav_links = Array.from(grabAll('.nav-item > .nav-link')),
    get_document_redacted = grab('[name=get_document_signed]'),
    connect_account = grab('.main_login_sign_up'),
    disconnect_account = grab('.main_logout_sign_up'),
    buy_product = grab('.buy_product'),
    file_url = Office.context.document.url || (default_name + default_ext);

    docName = file_url.getName();

    titles.forEach(function(title) { title.innerHTML = docName; });
    setLoginState().then(function(){
      loading_cover.classList.add('hide-loading');
    }).catch(function(){});
      

    nav_links.forEach(function(link) {
      link.addEventListener('click', function(evt) {
        evt.preventDefault();
        nav_links.forEach( function(l) {
          l.classList.remove('active');
          l.setAttribute('aria-selected',false);
          document.getElementById(l.hash.substr(1)).classList.remove('show','active');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected',true);
        document.getElementById(this.hash.substr(1)).classList.add('show','active');
      });
    });

    connect_account.addEventListener('click',connectAccount);
    disconnect_account.addEventListener('click',disconnectAccount);
    buy_product.addEventListener('click',function(){ purchaseSubscriptionImmediately(); });


    get_document_redacted.addEventListener('click',function(evt){
      if(!isRunning){
        var parent = this.closest('.pane_component');
        if(!isFormEmpty(parent)){
          getFileURL().then(function(file_url){
            get_document_redacted.querySelector('.fa-spin').makeVisible();
            var doc2Name = file_url.getName(),
            final_name = doc2Name.removeExt() + '.pdf';
            isRunning = true;
            uploadFileStream({docutype: 'user_document_to_sign',name: final_name})
            .then(redactDocument)
            .catch(handleUploadError)
            .finally(function(){
              get_document_redacted.querySelector('.fa-spin').makeHidden();
              isRunning = false;
            });
          }).catch(function(){
            notify('Could not determine file name','error');
            isRunning = false;
          });
        } else{
          parent.classList.add('was-validated');
          notify('Some data is missing','error');
        }
      } else {
        notify('Redaction process is running','error');
      }
    });
  } else {
    secondary_container.showItem();
    main_container.hideItem();
    loading_cover.classList.add('hide-loading');
  }

}

// ==================================


Office.onReady( function (info){

  var diag = getOfficeDiagnostics();
  if ( navigator.userAgent.indexOf("Trident") == -1){
    if (
      diag.platform.toLowerCase() == 'mac' && diag.version.indexOf("16.106") === 0
    ) {
       defaultMessage({
        title: 'Unsupported Office Version', 
        message: "This add-in won't run in your version of Office. Please upgrade your office or to a Microsoft 365 account."
      });
    } else if (diag.host == Office.HostType.PowerPoint && diag.platform_o == Office.PlatformType.OfficeOnline ) {
      defaultMessage({
        title: 'Unsupported Office Version', 
        message: "This add-in won't run in the online version of PowerPoint."
      });
    } else {
      installAddIn(info);
    }
  }
});


// ==================================


function getOfficeDiagnostics() {
    var version = "",
    platform = "",
    host = "",
    platform_o = "";

    if (typeof Office !== "undefined" &&
        Office.context &&
        Office.context.diagnostics) {

        if (Office.context.diagnostics.version) {
            version = Office.context.diagnostics.version;
        }

        if (Office.context.diagnostics.platform) {
            platform = Office.context.diagnostics.platform;
        }
    }

    if (typeof Office !== "undefined" && Office.context){
      if (Office.context.host) {
        host = Office.context.host;
      }
      if (Office.context.platform) {
        platform_o = Office.context.platform
      }
    }

    return {
        version: version,
        platform: platform,
        host: host,
        platform_o: platform_o
    };
}


function defaultMessage(info){
  var spinner = document.querySelector('.loading_cover > .spinner'),
    error_con   = document.querySelector('.error_container'),
    sub_message = error_con.querySelector('.sub_message'),
    message     = error_con.querySelector('.message');
    message.innerHTML = info.title;
    sub_message.innerHTML = info.message;
    spinner.className += 'd-none';
    error_con.className =  error_con.className.replace('d-none','');
}


function processMessage(arg) {
  var message = JSON.parse(arg.message);
  switch(message.status){
    case 'oauth':
      if(message.data.hasOwnProperty('code')){
        getAccessTokenFromCode(message.data.code).then(function(data){
          setToken(data);
          setLoginState().then(function(){
            notify("App authenticated",'success');
          }).catch(function(){
            notify("App authentication failed",'error');
          }).finally(function(){
            dialogBox.close();
          });
        }).catch(function(err){
          notify("Could not authenticate app.",'error');
          dialogBox.close();
        });
      } else {
        notify("Could not authenticate app.",'error');
      }
      break;
    case 'success_app_updated':
    case 'purchase_success':
      setLoginState()
      .catch(function(){})
      .finally(function(){
        dialogBox.close();
        notify(message.description,'success');
      });
      break;
    case 'finalize_redact':
      dialogBox.close();
      postRedaction(message);
      break;
    case 'app_success':
      dialogBox.close();
      notify(message.description,'success');
      break;
    case 'app_error':
      dialogBox.close();
      notify(message.description,'error');
      break;
    case 'fail_app_updated':
      setLoginState()
      .catch(function(){})
      .finally(function(){
        dialogBox.close();
        notify(message.description,'error');
      });
      break;
    case 'close_dialog':
      dialogBox.close();
      break;
  }
}


function postRedaction(data){
  if(data.hasOwnProperty('redacted_documents')){
    notifyConfirm("The redacted document is available on the Obfys platform at the 'documents' or 'redactions' page. Would you like to download the redacted document now?")
    .on('yes',function(){
      downloadFileObject(data.redacted_documents.download_enclosure).then(function(){
      }).catch(function(){
        notify("Could not download the file, please download at the Obfys portal.");
      });
    }).on('no',function(){
      notify(data.description,'success');
    }); 
  } else {
    notify(data.description,'success');
  }
};


function downloadFileObject(url) {
  return new Promise(function (resolve,reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET",url,true);
    xhr.responseType = "blob";
    xhr.withCredentials = false;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) { return; }
      if ( xhr.status < 200 || xhr.status >= 300) {
          reject( new Error( "Download failed with status " + xhr.status ));
          return;
      }

      try {
          var disposition = xhr.getResponseHeader("Content-Disposition");
          var contentType = xhr.getResponseHeader("Content-Type");
          var fileName = "redacted_download.pdf";
          if ( disposition) {
              var match = disposition.match(/filename="?([^"]+)"?/i);
              if ( match && match[1] ) {
                  fileName = match[1];
              }
          }
          var blobUrl = window.URL.createObjectURL(xhr.response);
          var a = document.createElement("a");
          a.href = blobUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout( function () {
            window.URL.revokeObjectURL(blobUrl);
          },1000);
          resolve({fileName: fileName, blob: xhr.response});
      } catch (err) {
        reject(err);
      }
    };

    xhr.onerror = function () {
      reject( new Error("Network error during download" ));
    };

    xhr.ontimeout = function () {
      reject(new Error("Download timed out"));
    };

    xhr.onabort = function () {
      reject(new Error("Download aborted"));
    };

    try {
      xhr.send();
    } catch (err) {
      reject(err);
    }
  });
};


function openDialog(url,refresh = false,displayInframe = false){
  Office.context.ui.displayDialogAsync(url,{
      displayInIframe: displayInframe
    },
    function(dbr){
    if(dbr.status === Office.AsyncResultStatus.Succeeded) {
      refreshOnDialogClose = refresh;
      dialogBox = dbr.value;
      dialogBox.addEventHandler(Office.EventType.DialogMessageReceived,processMessage);
      dialogBox.addEventHandler(Office.EventType.DialogEventReceived, processDialogEvent);
    } else {
      notify("Something went wrong internally, please contact support at support@docendorse.com",'error');
    }
  });
}


function redactDocument(item){
  if(item.status == 'success'){
    var url = base_url.concat('/apps/obfys_for_office/routines?',
      buildQuery({
        'instruct': 'init_document_redaction',
        'token': item.token || '',
        'slf_document_id': item.docid || '',
        'ref_path': "/apps/obfys_for_office/routines",
        'post_op': 'ext_links'
      })
    );
    openDialog(url);
  } else {
    notify("Could not upload file",'error');
  }
}



function connectAccount(){
  var codeVerifier = randomString(64);
  setVerifier(codeVerifier);
  pkceChallenge(codeVerifier).then(function (challenge){
    var params = buildQuery({
      'response_type': 'code',
      'client_id': 'client_a203b9525767c4ec931d3645725a7ea3',
      'redirect_uri': 'https://obfys.docendorse.com/apps/obfys_for_office/auth-complete',
      'scope': 'openid accounts:read files:write',
      'code_challenge': challenge,
      'code_challenge_method': 'S256'
    });
    openDialog("https://obfys.docendorse.com/oauth2/v1/authorize?".concat(params));
  }).catch(function(){
    notify("Could not generate access code, please contact support at support@docendorse.com",'error');
  });
}


function disconnectAccount(){
  webFetchPromise({
    'url': "https://obfys.docendorse.com/oauth2/v2/revoke",
    'type': 'POST',
    'content': "application/x-www-form-urlencoded",
    'payload': { 'token': get_token() },
    'responseType': 'json',
  }).then(function(res){
      localStorage.clear();
      openDialog(
        base_url.concat('/apps/obfys_for_office/routines?',
          buildQuery({
            'instruct': 'disconnect_item',
          })
        )
      );
  });
}


function getAccessTokenFromCode(code){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/oauth2/v2/token",
    'type': 'POST',
    'content': "application/x-www-form-urlencoded",
    'payload': { 
      'code': code,
      'client_id': 'client_a203b9525767c4ec931d3645725a7ea3',
      'redirect_uri': "https://obfys.docendorse.com/apps/obfys_for_office/auth-complete",
      'code_verifier': getVerifier(),
      'grant_type': "authorization_code",
     },
    'responseType': 'json',
  });
}


function generateToken(){
  return webFetchPromise({
    'url': "https://obfys.docendorse.com/api/v1/accounts/token",
    'type': 'GET',
    'content': "application/json",
    'authorization': get_token(),
    'responseType': 'json',
  });
}

function purchaseSubscriptionImmediately(){
  generateToken().then(function(item){
    if(item.status == 'success'){
      var url = base_url.concat('/apps/obfys_for_office/routines?',
        buildQuery({
          'instruct': 'init_purchase_now',
          'token': item.token || "",
          'ref_path': "/apps/obfys_for_office/routines"
        })
      );
      openDialog(url,true);
    } else {
      handleUploadError(item);
    }
  }).catch(function(){
    notify("Could not generate subscription link, please contact support",'error');
  });
}


function processDialogEvent(arg){
  switch (arg.error) {
    case 12002:
      notify("Cannot load page please contact support at support@docendorse.com.",'error');
      break;
    case 12003:
      notify("An unsecured page is being opened please contact support at support@docendorse.com","error");
      break;
    case 12006: 
      if(refreshOnDialogClose){
        setLoginState().catch(function(){});
        refreshOnDialogClose = false;
      }
      break;
    case 12009:
      notify("Blocking the pop up will prevent the operation from being carried out. Please enable the popup to continue.","error"); 
      break;
    case 12011:
      notify("Your browser is configured to block popups, please enable popup or use different browser to continue.","error"); 
      break;
    default: break;
  }
}



function setLoginState(){
    return new Promise(function(resolve,reject){
      let scene;
      loginState().then( (_state) => {
        var state = JSON.parse(_state);
        if (state.reg.status == 'success'){
          scene = setScene('signed_in',state.user);
        }else if (state.reg.status =='require_action') {
          if(state.reg.action == 'purchase_subscription'){
            scene = setScene('signed_in_no_product',state.user);
          } else if(state.reg.action == 'register'){
            scene = setScene('signed_out');
          } else if (state.reg.action == 'verify_email'){
            scene = setScene('signed_out');
            notify('Your email/account has not been verified. Please check your email for the verification link.','error');
          } else {
            scene = setScene('signed_out');
          }
        }
        scene.then(resolve).catch(reject);
      }).catch(function(err){
        console.log(err);
        scene = setScene('signed_out');
        scene.then(resolve).catch(reject);
      });
    });
}


function loginState(){
  return webFetchPromise({
      'url': base_url + '/api/v1/accounts/status',
      'type': 'get',
      'content': "application/json",
      'responseType': 'text',
      'authorization': get_token()
  });
}


function setScene(scene,data = {}){
  var visible_on_logged_out = Array.from(grabAll('.visible_on_logged_out')),
  visible_on_logged_in = Array.from(grabAll('.visible_on_logged_in')),
  paid_esign_plan = Array.from(grabAll('.paid_esign_plan')),
  esign_tip = grab('.esign_tip'),
  profile = grab('.box-profile'),
  buy = grab('.buy_product');

  esign_tip.innerHTML = "You need to connect your app to your Obfys account to redact documents";
  
  switch(scene){
    case 'signed_in':
      visible_on_logged_in.forEach(function(el) { el.showItem(); } );
      visible_on_logged_out.forEach(function(el) { el.hideItem(); } );
      paid_esign_plan.forEach(function(el) { el.showItem(); } );
      buy.hideItem();
      esign_tip.hideItem();
      break;
    case 'signed_out':
      visible_on_logged_in.forEach(function(el){ el.hideItem(); } );
      visible_on_logged_out.forEach(function(el){ el.showItem(); } );
      paid_esign_plan.forEach(function(el) { el.hideItem(); } );
      esign_tip.showItem();
      break;
    case 'signed_in_no_product':
      visible_on_logged_in.forEach(function(el) { el.showItem(); } );
      visible_on_logged_out.forEach(function(el) { el.hideItem(); } );
      paid_esign_plan.forEach(function(el) { el.hideItem(); } );
      esign_tip.showItem();
      esign_tip.innerHTML = "You need to purchase an Obfys subscription.";
      buy.showItem();
      break;
  }
  return setHTMLData(profile,data);
}


function setToken(data){
  localStorage.setItem("access_token", data.access_token);
}

function get_token(){
  return localStorage.getItem("access_token");
}


function setVerifier(chl){
  localStorage.setItem("code_challenge",chl);
}

function getVerifier(){
  return localStorage.getItem("code_challenge");
}


function uploadFileStream(docData){
  return new Promise(function(resolve,reject){

  //  Office.FileType.Compressed || Office.FileType.Pdf;

    Office.context.document.getFileAsync(
      Office.FileType.Pdf,{ sliceSize: 65536 },
        function (result) {
          if (result.status === Office.AsyncResultStatus.Succeeded) {
              var myFile = result.value, counter = 0;
              docData.total_chunks = myFile.sliceCount;
               var uplodNextChunk = function(){

                  myFile.getSliceAsync(counter,function (slice) {
                    if(slice.status == Office.AsyncResultStatus.Succeeded){
                      counter++;
                      docData.chunk_number = counter;
                      bufferToBase64(slice.value.data).then(function(src){
                          docData.data = src.split(',')[1];
                          docData.type = (src.split(';')[0]).split(':')[1];

                          webFetchPromise({
                            'url': base_url+ '/api/v1/files/upload_multipart',
                            'type': 'post',
                            'payload': docData,
                            'content': "application/json",
                            'responseType': 'json',
                            'authorization': get_token()
                          }).then(function(data){
                            if(data.status == 'success'){
                              if(counter < myFile.sliceCount) {
                                uplodNextChunk();
                              } else {
                                myFile.closeAsync(function (post) {
                                  if(post.status === Office.AsyncResultStatus.Succeeded) {
                                    resolve( data );
                                  } else {
                                    reject({
                                      status: 'error',
                                      description: post.error.message + ' level 4'
                                    });
                                  }
                                });
                              }
                            } else {
                              myFile.closeAsync(function (post) {
                                if(post.status === Office.AsyncResultStatus.Succeeded) {
                                  reject(data);
                                } else {
                                  reject({
                                    status: 'error',
                                    description: post.error.message + ' level 3'
                                  });
                                }
                              });
                            }
                          }).catch(function(error){
                            myFile.closeAsync(function (post) {
                              reject(error.server_error);
                            });
                          });
                      }).catch(function(){
                        myFile.closeAsync(function (post) {
                          reject({
                            status: 'error',
                            description: 'Could not base64 encode data.'
                          });
                        });
                      });
                    } else {
                      myFile.closeAsync(function (post) {
                        reject({
                          status: slice.status,
                          description: slice.error.message + ' level 2'
                        });

                      });
                    }
                  });
               };
               uplodNextChunk();
          } else {
            reject({
              status: result.status,
              description: result.error.message + ' level 1'
            });
          }
      });
  });
}


function bufferToBase64(buffer) {
  return new Promise(function(r){
    var reader = new FileReader();
    reader.onload = function(){
      r(reader.result);
    }
    reader.readAsDataURL( new Blob(
      [new Uint8Array(buffer)],
      { type: 'application/pdf' }
      ));
  });
}


function getFileURL(){
  return new Promise(function(r){
    Office.context.document.getFilePropertiesAsync(function (fProp){
      if(fProp.status == Office.AsyncResultStatus.Succeeded){
        r( fProp.value.url || "unsaved_file" + default_ext );
      } else {
        r("unsaved_file" + default_ext);
      }
    });
  });
}



function handleUploadError(err){
  if(err.status == 'no_perms'){
    notify('Your app is disconnected. Please reconnect','error');
    setLoginState().catch(function(){});
  } else if (err.status == 'purchase_plan_app_connection'){
    notify('You need to purchase a subscription','error');
    setLoginState().catch(function(){});
  } else {
    notify("Could not upload file please try again or contact support at support@docendorse.com",'error');
  }
}


function base64UrlEncode(bytes) {
    var str = btoa(String.fromCharCode.apply(null, bytes));
    return str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function randomString(length){
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    var result = "";
    for (var i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

function pkceChallenge(verifier) {
    if (window.crypto && window.crypto.subtle) {
        var encoder = new TextEncoder();
        var data = encoder.encode(verifier);
        return crypto.subtle.digest("SHA-256", data).then(function (buffer) {
            return base64UrlEncode(new Uint8Array(buffer));
        });
    }
    return Promise.resolve(verifier);
}